import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'app-dialog-common-error',
    templateUrl: 'dialog-common-error.component.html',
    styleUrls: ['dialog-common-error.component.scss']
})
export class DialogCommonError implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DialogCommonError>,
        @Inject(MAT_DIALOG_DATA) public errorMessage: any
    ) {}

    ngOnInit() {}

    dismissDialog(){
        this.dialogRef.close();
    }
}
